import React, { useState, useEffect } from 'react';
import { Lock, Hash } from 'lucide-react';
import styles from './form.module.css';

const GuessNumberForm = ({ content, onSubmit, isPreview = false, isLocked = false, userAnswer = null, allowUpdateResponse = true }) => {
    const [guess, setGuess] = useState(() => userAnswer?.guess !== undefined ? String(userAnswer.guess) : '');
    const [error, setError] = useState('');

    useEffect(() => {
        setGuess(userAnswer?.guess !== undefined ? String(userAnswer.guess) : '');
        setError('');
    }, [userAnswer]);

    const hasSubmitted = userAnswer != null;
    const isDisabled = isLocked || (hasSubmitted && !allowUpdateResponse);
    const numVal = parseFloat(guess);
    const isValid = guess.trim() !== '' && !isNaN(numVal);
    const isUnchanged = hasSubmitted && isValid && numVal === userAnswer.guess;
    const submitDisabled = isPreview || isLocked || !isValid || (hasSubmitted && (!allowUpdateResponse || isUnchanged));
    const submitLabel = !hasSubmitted ? (isLocked ? 'Voting Closed' : 'Submit Guess') : (!allowUpdateResponse || isUnchanged ? 'Submitted ✓' : 'Update guess');

    const handleSubmit = () => {
        if (submitDisabled) return;
        if (!isValid) { setError('Please enter a valid number.'); return; }
        onSubmit({ guess: numVal });
    };

    return (
        <div className={styles.form}>
            <div className={styles.question}>
                {content.question || 'Guess the number!'}
                {isLocked && <span className={styles.lockBadge}><Lock size={12} aria-hidden="true" /> Voting Locked</span>}
            </div>
            {content.settings?.description && content.settings?.descText && (
                <div className={styles.description}>{content.settings.descText}</div>
            )}
            <div style={{ textAlign: 'center', padding: 'var(--space-4) 0' }}>
                <div style={{ display: 'flex', justifyContent: 'center', color: 'var(--primary-500)', marginBottom: 'var(--space-2)' }}>
                    <Hash size={40} aria-hidden="true" />
                </div>
                <input
                    type="number"
                    className={styles.textInput}
                    value={guess}
                    onChange={(e) => { if (!isDisabled) { setGuess(e.target.value); setError(''); } }}
                    placeholder="Enter your guess…"
                    disabled={isDisabled}
                    style={{ textAlign: 'center', fontSize: 'var(--text-xl)', fontWeight: 'var(--font-bold)', maxWidth: 200 }}
                />
            </div>
            {error && <p className={styles.profanityError}>{error}</p>}
            <button className={styles.submitBtn} onClick={handleSubmit} disabled={submitDisabled}>
                {submitLabel}
            </button>
        </div>
    );
};

export default GuessNumberForm;
